import { useUser } from "lib/user";
import { useEffect, useState } from "react";

export const useIsMember = (): boolean => {
  const user = useUser();
  const [isMember, setIsMember] = useState(false);

  useEffect(() => {
    setIsMember(user.isMember);
  }, [setIsMember, user.isMember]);

  return isMember;
};
